import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { api } from "@/lib/api";
import { SmoothScroll } from "@/lib/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import { PortfolioIndex, PortfolioDetail } from "@/pages/Portfolio";
import { CoursesIndex, CourseDetail } from "@/pages/Courses";
import { BlogIndex, BlogDetail } from "@/pages/Blog";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import NotFound from "@/pages/NotFound";
import FAQ from "./pages/FAQ";
import WatchVideo from "./pages/WatchVideo";
import SEO from "./components/SEO";
function App() {
  useEffect(() => {
  api.get("/").catch(() => {});
}, []);
  return (
    <div className="App bg-brand-bg text-white min-h-screen">
      <BrowserRouter>
        <SEO />
        <SmoothScroll>
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/portfolio" element={<PortfolioIndex />} />
              <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
              <Route path="/courses" element={<CoursesIndex />} />
              <Route path="/courses/:slug" element={<CourseDetail />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/watch/dorado9-film-001" element={<WatchVideo />} />
              <Route path="*" element={<NotFound />} />
              <Route path="/faq" element={<FAQ />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}


export default App;
